export default __webpack_public_path__ + "media/application/assets/images/signing-instructions/2WitANDNotary-WITNESS-53348cbd08b57477f89a5887a7b5238b.PNG";